import { FancyInformationMessage, OverlayPortal } from '@morressier/ts';
import { FaVideo } from 'react-icons/fa';

import { FeatureFlags } from 'config/featureFlags';
import { useCountDown } from 'utils/countDown';
import React from 'react';

export const DelegateAcceptModal = ({
  showRequestAcceptModal,
  setShowRequestAcceptModal,
  hostName,
  onClickDeclineToJoinBackstage,
  onClickAcceptToJoinBackstage,
  timeLeftToAccept,
}: {
  showRequestAcceptModal: boolean;
  setShowRequestAcceptModal: (status: boolean) => void;
  hostName: string;
  onClickDeclineToJoinBackstage: () => void;
  onClickAcceptToJoinBackstage: () => void;
  timeLeftToAccept: number;
}) => {
  const { timeLeft, setTimeLeft } = useCountDown(timeLeftToAccept, 1, showRequestAcceptModal);
  React.useEffect(() => {
    setTimeLeft(timeLeftToAccept);
  }, [timeLeftToAccept, setTimeLeft, showRequestAcceptModal]);

  // automatically decline the invitation after 40 seconds
  React.useEffect(() => {
    if (timeLeft === 0) {
      onClickDeclineToJoinBackstage();
      setShowRequestAcceptModal(false);
    }
    if (showRequestAcceptModal && timeLeft < 1) {
      setTimeLeft(timeLeftToAccept);
    }
  }, [timeLeft, showRequestAcceptModal]);

  return (
    <>
      {FeatureFlags.Enable_Delegate_To_Stage.isEnabled() && showRequestAcceptModal && (
        <OverlayPortal color="#424d5d69">
          <FancyInformationMessage
            icon={FaVideo}
            title={`${hostName} has accepted your request to join the ${'\n\n'} Stage.`}
            subline={`The invitation expires in ${timeLeft} seconds...`}
            actions={[
              {
                method: () => {
                  setShowRequestAcceptModal(false);
                  onClickDeclineToJoinBackstage();
                },
                text: 'Not Now',
                color: 'secondary',
                styles: { minWidth: '9rem', marginRight: '1rem' },
              },
              {
                method: () => {
                  onClickAcceptToJoinBackstage();
                },
                text: 'Join Stage',
                color: 'primary',
                styles: { minWidth: '9rem' },
              },
            ]}
            style={{
              padding: '2rem',
              backgroundColor: '#FFFFFF',
              borderRadius: '8px',
              height: '409px',
              width: '685px',
            }}
          />
        </OverlayPortal>
      )}
    </>
  );
};
